import { SET_ROUTE } from '../actions/routeAction';

const initialState = {
    checkRoute: false,
    routes: ['/member/dashboard', '/member/sponsor-tree'],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_ROUTE:
            return { ...state, routes: action.routes };
        default:
            return state;
    }
}
